export default __webpack_public_path__ + "static/media/Home_thmb.e37acc9e.jpg";